import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ManageContentDescriptorTypes = ({ location }) => {
  const [contentDescriptorTypeCodes, setContentDescriptorTypeCodes] = useState(
    []
  );
  const [message, setMessage] = useState("");
  const {token,userMetadata}=useAuth()
  const history = useHistory();
  let parms = new URLSearchParams(location.search);

  const [state, setState] = useState({
    contentDescriptorTypeId: parseInt(parms.get("id")),
    contentDescriptorTypeValue: 0,
    contentDescriptorTypeDescr: "",
    contentDescriptorTypeCdata: "",
    contentDescriptorTypeBdata: "",
    securityContextId: 0,
    createUser: 0,
    createDate: new Date().toISOString(),
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");

    var url = `${globalConfig.apiDatahubUrl}/content-descriptor-types/${state.contentDescriptorTypeId}`;

    axios
      .patch(url, state, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(response.status + ":" + response.data.contentInputSourceId);

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_DESCRIPTOR_TYPE`,
        apiHeader(token)
      )
      .then((res) => {
        const contentDescriptorTypeCodes = res.data;
        console.log("results", contentDescriptorTypeCodes);
        setContentDescriptorTypeCodes(contentDescriptorTypeCodes);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });

    console.log(
      "handleOnLoad() - loading id = " + state.contentDescriptorTypeId
    );
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-descriptor-types/${state.contentDescriptorTypeId}`,
        apiHeader(token)
      )
      .then((res) => {
        const contentType = res.data;
        console.log("contentType");
        console.log(contentType);
        setState(contentType);
        console.log("state");
        console.log(state);
      });
  };

  function onDelete() {
    let deleteID = state.contentDescriptorTypeId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-descriptor-types/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        history.goBack();
      })
      .catch((err) => console.log("Err delete:" + err));
  }

  return (
    <form>
      <div className="container-fluid">
      <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => history.goBack()}
        >
          Go Back
        </button>
        <h4>Content Descriptor Type Details</h4>
        <hr />
        <div columns="2">
          <div className="form-group row">
            <label
              className="ContentTitle col-sm-2"
              value="Content Descriptor Type"
            >
              Content Descriptor Type
            </label>
            <select
              id="contentDescriptorTypeId"
              onchange="submit()"
              value="#{ombContentDescriptorTypeForm.currentContentDescriptorType.contentDescriptorTypeId}"
              className="form-control input-xlarge col-sm-8"
              valueChangeListener="#{ombContentDescriptorTypeForm.get }"
            >
              <option value="#{ombContentDescriptorTypeForm.contentDescriptorTypeSelectList}" />
            </select>
          </div>
          <div className="form-group row">
            <label
              className="ContentTitle col-sm-2"
              value="Content Descriptor Type Value Code"
            >
              Content Descriptor Type Value Code
            </label>
            <select
              id="contentDescriptorTypeValue"
              onChange={handleChange}
              className="form-control input-xlarge col-sm-8"
              value={state.contentDescriptorTypeValue}
            >
              <option value={0}>Select Descriptor Type Value Code </option>
              {contentDescriptorTypeCodes.map(
                ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                  <option key={systemCodeValueId} value={systemCodeValueId}>
                    {systemCodeValueValue}{" "}
                  </option>
                )
              )}
            </select>
            {/* <SelectListComponent entityName ={"system-code-values"} valueFilterColumnName = {"systemCodeId"} valueFilter = {"234"} displayColumnName ={"systemCodeValueValue"} keyColumnName ={"systemCodeValueId"}
					IdName={"contentDescriptorTypeValue"}
					TypeId={state.contentDescriptorTypeValue}
					handle={handleDropDown}
					/>	 */}
          </div>
          {/* <div className="form-group row">
				<label className="ContentTitle col-sm-2" value="Content Descriptor Type Value Code">My select object</label>
				<SelectListComponent />	
			</div> */}
          <div className="form-group row">
            <label
              className="ContentTitle col-sm-2"
              value="Content Descriptor Type Description"
            >
              Content Descriptor Type Description
            </label>
            <textarea
              id="contentDescriptorTypeDescr"
              className="form-control input-xlarge col-sm-8"
              value={state.contentDescriptorTypeDescr}
              onChange={handleChange}
            />
          </div>
          <div className="form-group row">
            <label
              className="ContentTitle col-sm-2"
              value="Content Descriptor Type CData"
            >
              Content Descriptor Type CData
            </label>
            <input
              id="contentDescriptorTypeCdata"
              className="form-control input-xlarge col-sm-8"
              value={state.contentDescriptorTypeCdata}
              onChange={handleChange}
            />
          </div>
          <div className="form-group row">
            <label
              className="ContentTitle col-sm-2"
              value="Content Descriptor Type BData"
            >
              Content Descriptor Type BData
            </label>
            <input
              id="contentDescriptorTypeBdata"
              className="form-control input-xlarge col-sm-8"
              value={state.contentDescriptorTypeBdata}
              onChange={handleChange}
            />
          </div>
        </div>
        <hr />
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Last Updated By #{ombUserSession.getUserNameForId(contentTemplateForm.currentContentTemplate.lastUpdateUser)} on "
          >
            Last Updated By
          </label>
          <input
            className="form-control col-sm-1"
            readonly="readonly"
            value={state.lastUpdateUser}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="#{contentTemplateForm.currentContentTemplate.lastUpdateDate}"
          >
            Last Update Date
          </label>
          <input
            className="form-control col-sm-8"
            readonly="readonly"
            value={state.lastUpdateDate.slice(0, 16)}
            type="datetime-local"
          />
        </div>
        <hr />
        <button
          className="btn btn-danger"
          value="Delete"
          onClick={onDelete}
        >
          Delete
        </button>
        &nbsp;
        <button className="btn btn-success" value="Save" onClick={handleSave}>
          Save
        </button>
        &nbsp;

        {/* <button
          className="btn btn-primary"
          value="Clear"
          actionListener="#{ombContentDescriptorTypeForm.clear }"
        >
          Clear
        </button> */}
      </div>
    </form>
  );
};

export default ManageContentDescriptorTypes;
